const STORY_DETAIL_LIST_DURATION = 5000;
const STORY_DETAIL_LIST_PROGRESS_INTERVAL = 10;

export {
  STORY_DETAIL_LIST_DURATION,
  STORY_DETAIL_LIST_PROGRESS_INTERVAL,
};
